(() => {
  const selector = '[data-pajama-size]';

  const syncPanel = (panel) => {
    const productInfo = panel.closest('.product__info-container');
    const picker = productInfo?.querySelector('variant-selects');
    const setSelected = Boolean(picker?.querySelector('[data-set-option]:checked'));
    const sizes = panel.querySelectorAll('[data-pajama-size-field]');
    const customFields = panel.querySelectorAll('[data-pajama-custom-field]');
    const customBox = panel.querySelector('[data-pajama-custom]');
    const buyNow = productInfo?.querySelector('[data-editorial-buy-now]');

    panel.hidden = !setSelected;
    sizes.forEach((field) => {
      field.disabled = !setSelected;
    });

    // Preselect the pajama size that matches the kurta size, until the shopper picks one.
    if (setSelected && !panel.dataset.pajamaPicked) {
      const kurtaSize = picker.querySelector('input[name^="Size-"]:checked, select[name="options[Size]"]')?.value;
      const match = Array.from(sizes).find((field) => field.value === kurtaSize);
      if (match) match.checked = true;
    }

    const customPicked = setSelected && panel.querySelector('[data-pajama-size-field][value="Custom"]:checked');
    if (customBox) customBox.hidden = !customPicked;
    customFields.forEach((field) => {
      field.disabled = !customPicked;
    });
    const kurtaCustom = Boolean(picker?.querySelector('[data-custom-size-option]:checked'));
    if (buyNow) {
      buyNow.hidden = Boolean(customPicked) || kurtaCustom;
      buyNow.disabled = Boolean(customPicked) || kurtaCustom;
    }
  };

  const initialize = () => {
    document.querySelectorAll(selector).forEach((panel) => {
      if (panel.dataset.pajamaSizeInitialized) return;
      panel.dataset.pajamaSizeInitialized = 'true';
      panel.addEventListener('change', (event) => {
        if (event.target.matches('[data-pajama-size-field]')) panel.dataset.pajamaPicked = 'true';
        syncPanel(panel);
      });
      syncPanel(panel);
    });
  };

  // variant-selects is replaced on every option change, so listen on the document.
  document.addEventListener('change', (event) => {
    if (!event.target.closest('variant-selects')) return;
    document.querySelectorAll(selector).forEach(syncPanel);
  });
  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
